<template>
  <div class="main stake">
        <div class='container'>
            <!-- Locked Funds -->
            <b-row class='mb-5'>
              <LockedFunds :amount="getSupply('SGBT-ST')"/>
            </b-row>
            <!-- form -->
            <b-row class='pt-2'>
              <FormComponets
              type='team'
              balance= "0"
              _disabled= "false"
              />
              <DistributionComponets
                type='team'
                :dataPieChart='this.getValues'
                :linkSC='this.getLinkSC'
              />
            </b-row>
            <!-- list-->
            <b-row class='mb-5 pt-3'>
                <b-col cols=12>
                    <h4 class="mb-0 pb-3 text-center txt-color-secondary">Movements</h4>
                </b-col>
                <MovementsComponents :list='this.getMovements'/>
            </b-row>
            <div style="height: 100px"></div>
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SmartGlobalIcon from '@/components/icons/SmartGlobalIcon'
import LockedFunds from '@/components/stake/LockedFundsComponets'
import FormComponets from '@/components/stake/formComponets'
import DistributionComponets from '@/components/stake/distributionComponents'
import MovementsComponents from '@/components/stake/movementsComponents'
import ApiWallet from '@/services/ApiWallet.service'

export default {
  components: {
    LockedFunds,
    FormComponets,
    DistributionComponets,
    MovementsComponents
  },
  data () {
    return {
      values: [],
      linkSC: 'https://tronscan.org/#/token20/TCqdu9enyuh3TiX4HiwVbGovf24YiMKgYz/holders',
      movements: [],
      assets: {
        trc20: [
          {
            component: SmartGlobalIcon,
            properties: {
              width: 25,
              height: 25,
              fill: '#FFF9BC'
            },
            name: 'Smart Global',
            symbol: 'SGBT',
            address: '',
            balance: 0,
            price: '--',
            precision: 9
          }
        ]
      },
      tronGrid: null,
      smartContrac: {
        error: false,
        list: [
          {
            name: 'SGBT',
            address: 'TCdCXwD9GPmJUVaB64KeGU6ovd34XgFNe7',
            supply: 1000000000000000000,
            instance: null
          },
          {
            name: 'SGBT-ST',
            address: 'TCqdu9enyuh3TiX4HiwVbGovf24YiMKgYz',
            supply: 0,
            instance: null
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getStatusAuthWallet: 'auth/getStatusAuthWallet',
      getOptionsAuthWallet: 'auth/getOptionsAuthWallet'
    }),
    getValues () { return this.values },
    getLinkSC () { return this.linkSC }
  },
  watch: {
    async getStatusAuthWallet (_new, old) {
      if (this.$store.getters.walletIsInstalled) {
        this.notLoggedIn()
      } else {
        if (_new === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    }
  },
  async created () {
    this.update()
  },
  async mounted () {},
  async updated () {},
  methods: {
    update () {
      // get SGBT Locked
      if (this.$store.getters.walletIsInstalled) {
        this.notLoggedIn()
      } else {
        // NOT LOGGED IN
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    },
    async notLoggedIn () {
      this.$store.commit('setLoading', true)
      try {
        this.tronGrid = new ApiWallet()
        await this.getContractAssets()
        if (!this.smartContrac.error) {
          await this.updateWithExtension()
        }
      } catch (e) { console.log({ e }) }
      this.$store.commit('setLoading', false)
    },
    async getContractAssets () {
      try {
        if (this.smartContrac.list[0].instance === null) {
          this.smartContrac.list[0].instance = await this.tronGrid.getContract(this.smartContrac.list[0].address)
        }
        //
        if (this.smartContrac.list[1].instance === null) {
          this.smartContrac.list[1].instance = await this.tronGrid.getContract(this.smartContrac.list[1].address)
        }
      } catch (e) {
        this.smartContrac[0].instance = null
        this.smartContrac[1].instance = null
        this.smartContrac.error = true
        console.log('error: getContractAssets', { e })
      }
    },
    async updateWithExtension () {
      // get supply SGBT
      await this.setSupplySGB()
      // get supply SGBT-ST
      await this.setSupplySGB_TS()
      //
      this.values = []
      this.values.push({ name: 'Unlocked', value: 0, show: false })
      this.values.push({ name: 'Locked', value: 0, show: true })
      this.values[1].value = this.getSupply('SGBT-ST')
      this.values[0].value = this.getSupply('SGBT') - this.values[1].value
      // get list
      await this.setList()
    },
    getSupply (name) {
      return this.smartContrac.list.find(item => item.name === name).supply
    },
    getMovements () {
      return this.movements
    },
    async setList () {
      this.movements = []
      var diasMS = 24 * 60 * 60 * 1000
      var list = []
      try {
        // get events _buySGBUSD
        var today = new Date()
        const events = await this.tronGrid.getEventByContract(this.smartContrac.list[1].address, 'event_stake')
        events.data.data.forEach(element => {
          list.push({
            id: element.transaction_id,
            address: this.tronGrid.tronWeb.address.fromHex(element.result.account),
            value: this.GLOBAL._toDecimal(element.result.amount, 9),
            start: element.block_timestamp,
            contador: Math.trunc(((new Date(element.block_timestamp).getTime() + (365 * diasMS)) - today.getTime()) / diasMS) + ' days'
          })
        })
        this.movements = list
      } catch (e) { console.log({ e }) }
    },
    async setSupplySGB () {
      const supply = await this.smartContrac.list[0].instance.totalSupply().call()
      this.smartContrac.list[0].supply = this.tronGrid.tronWeb.toDecimal(supply._hex)
    },
    async setSupplySGB_TS () {
      const supply = await this.smartContrac.list[1].instance.totalSupply().call()
      this.smartContrac.list[1].supply = this.tronGrid.tronWeb.toDecimal(supply._hex)
    }
  }
}
</script>

<style scoped>
</style>
